import * as React from 'react';
import RangedNumberFilterEdit from './RangedNumberFilterEdit';
import { RangedValueFilterEditProps } from '../providers/RangedValue';

interface RangedDecimalFieldEditState {
	fromValue: string;
	toValue: string;
}

/**
 * Configures a range of decimal values in a filter
 */
class RangedDecimalFilterEdit extends React.PureComponent<RangedValueFilterEditProps, RangedDecimalFieldEditState> {
	constructor(props) {
		super(props);
	}

	public render() {
		return <RangedNumberFilterEdit {...this.props} step="0.01" />;
	}
}

export default RangedDecimalFilterEdit;
